import default_ from "./default.json" with { type: "json" };

export default {
	...default_,
} as const;
